import { render, staticRenderFns } from "./ShopifyWebhooks.vue?vue&type=template&id=0e18e72c&"
import script from "./ShopifyWebhooks.vue?vue&type=script&lang=js&"
export * from "./ShopifyWebhooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports